import React from 'react';
import {
  BestTreatmentsBadge,
  BestTreatmentsBadgeStyle,
} from 'js/components/BestTreatmentsBadge';
import { WaveBoi } from 'js/components/WaveBoi/WaveBoi';
import { ButtonAnchor } from 'js/components/ButtonAnchor/ButtonAnchor';
import { ButtonColour, ButtonSize } from 'js/components/Button';
import styles from './CrossLinks.module.css';

interface Props {
  heading: string;
  badge: string;
  treatments: {
    treatmentName: string;
    treatmentId: number;
    uri: string;
    onClick?: (event: React.SyntheticEvent<HTMLAnchorElement>) => void;
  }[];
}

export function CrossLinks(props: Props): React.ReactElement {
  const { heading, badge, treatments } = props;
  return (
    <>
      <div className={styles.waveBoiContainer}>
        <div className={styles.waveBoi}>
          <WaveBoi />
        </div>
      </div>
      <div className={styles.container}>
        <div className={styles.header}>
          <div className={styles.heading}>{heading}</div>
          <div className={styles.badge}>
            <BestTreatmentsBadge
              label={badge}
              style={BestTreatmentsBadgeStyle.Solid}
            />
          </div>
        </div>
        <div className={styles.buttons}>
          {treatments.map((link) => (
            <div key={link.treatmentName} className={styles.button}>
              <ButtonAnchor
                label={link.treatmentName}
                href={link.uri}
                colour={ButtonColour.WhiteOutline}
                size={ButtonSize.Medium}
                onClick={link.onClick}
              />
            </div>
          ))}
        </div>
      </div>
    </>
  );
}
